export default function getSubscriptionVariantsAmount(subscriptionVariants, checkoutQuantity) {
  if (!subscriptionVariants || !subscriptionVariants.length) return 0;

  return subscriptionVariants.reduce((acc, variant) => {
    if (!variant || (!variant.selectedOption && !variant.selectedOptions)) {
      return acc + 0;
    }

    if (variant.selectionType === 'single') {
      const { additionalChargeAmount } = variant.selectedOption;

      if (variant.selectedOption.type !== 'recurring') return acc + 0;

      if (variant.increasesWithQuantity) {
        const amount = additionalChargeAmount * checkoutQuantity;
        return acc + amount || 0;
      } else {
        return acc + additionalChargeAmount || 0;
      }
    } else if (variant.selectionType === 'quantity') {
      const additionalChargeAmount = variant.selectedOptions.reduce((acc, selectedOption) => {
        if (!selectedOption) return acc + 0;

        if (selectedOption.type !== 'recurring') return acc + 0;

        if (selectedOption.quantity === 0) return acc + 0;

        const amount = selectedOption.additionalChargeAmount * selectedOption.quantity;

        return acc + amount || 0;
      }, 0);

      return acc + additionalChargeAmount || 0;
    } else if (variant.selectionType === 'multiple') {
      const additionalChargeAmount = variant.selectedOptions.reduce((acc, selectedOption) => {
        if (!selectedOption) return acc + 0;

        if (selectedOption.type !== 'recurring') return acc + 0;

        if (selectedOption.quantity === 0) return acc + 0;

        if (variant.increasesWithQuantity) {
          const amount = selectedOption.additionalChargeAmount * checkoutQuantity;
          return acc + amount || 0;
        } else {
          const amount = selectedOption.additionalChargeAmount * selectedOption.quantity;

          return acc + amount || 0;
        }
      }, 0);

      return acc + additionalChargeAmount || 0;
    }
  }, 0);
}
